export const getContentFieldType = (data): string | null => {
  return data?.sys?.contentType?.sys?.id || null;
};
